import {PublicInfoType} from "./publicInfoType.model";
import {ContactType} from "./contactType.model";
import {RegInfoCPType} from "./regInfoCPType.model";
import {OkvedType} from "./okvedType.model";
import {DocumentInfoType} from "./documentInfoType.model";
import {PersonalDataType} from "./personalDataType.model";
import {FIOType} from "./fioType.model";
import {AddressInfoType} from "./addressInfoType.model";

export class SvedFLCPType {
  fio: FIOType = new FIOType();
  personalData: PersonalDataType = new PersonalDataType();
  documentInfo: Array<DocumentInfoType> = undefined;
  okved: OkvedType = undefined;
  regInfoCP: RegInfoCPType = new RegInfoCPType();
  addressInfo: AddressInfoType = new AddressInfoType();
  contactInfo: ContactType = new ContactType();
  publicInfo?: PublicInfoType = new PublicInfoType();
}
